module.exports = __webpack_public_path__ + "img/play-big.f78f52bb.png";